import {Request} from '@/apis'

export function page(params) {
    return Request.get("/jx/inspect/page", params);
}

export function getDetail(id) {
    return Request.get(`/jx/inspect/detail/${id}`, {});
}

export function saveObj(obj) {
    return Request.post(`/jx/inspect`, obj);
}

export function replenish(obj) {
    return Request.post(`/jx/inspect/replenish`, obj);
}

export function deleteObj(id) {
    return Request.delete("/jx/inspect/" + id);
}

export function exportData(params) {
    return Request.export("/jx/inspect/export", params);
}
